import { render, staticRenderFns } from "./VeilleSanitaire.vue?vue&type=template&id=3fd45e56"
import script from "./VeilleSanitaire.vue?vue&type=script&lang=js"
export * from "./VeilleSanitaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports